// Real RollOver photography already in the repository. These replace the
// stock context imagery used by the site.
import store1 from "../../components/Lightbox/media/IMG_1487.jpg";
// Lightbox/media/img3.jpg (gift bags at the counter) stays in source but is
// intentionally not published anywhere on the site.
import party from "../../components/Lightbox/media/img6.jpg";
import pour from "../../components/AboutUs/media/img2.JPG";
import brownies from "../../components/AboutUs/media/img3.JPG";
import deathByChocolate from "../../components/AboutUs/media/Death by Chocolate 2.jpg";
import signage from "../../components/Image/images/img3.jpg";
import rollsClose from "../../components/Menuall/ProImages/Menu Pic_s for Website/Icecreamrolls/Choco chip cookie dough.JPG";
import rollsSnicker from "../../components/Menuall/ProImages/Menu Pic_s for Website/Icecreamrolls/Sniker Roll.jpeg";
import burger from "../../components/Menuall/ProImages/Menu Pic_s for Website/Burger/veg cheeseburger.jpg";
import shake from "../../components/Menuall/ProImages/Menu Pic_s for Website/Milkshakes/dairymilk shake.jpg";
import fries from "../../components/Menuall/ProImages/Menu Pic_s for Website/Quickbites/frenchfries.jpg";
import sandwich from "../../components/Menuall/ProImages/Menu Pic_s for Website/Sandwiches/smoked panner.jpg";
import sundae from "../../components/Menuall/ProImages/Menu Pic_s for Website/Exoticsundaes/sundae strawberry.jpg";
import momos from "../../components/Menuall/ProImages/Menu Pic_s for Website/Momos/peri peri chickensteamed.jpg";
import pizzaPromo from "../../components/AnimatedCards/Media/pizza1.jpg";

export const photos = {
  store1,
  party,
  pour,
  brownies,
  deathByChocolate,
  signage,
  rollsClose,
  rollsSnicker,
  burger,
  shake,
  fries,
  sandwich,
  sundae,
  momos,
  pizzaPromo,
};

export const galleryPhotos = [
  { src: store1, alt: "Guests at the RollOver counter during an event" },
  { src: pour, alt: "Sauce being poured over a dessert at the RollOver counter" },
  { src: brownies, alt: "Brownies with chocolate drizzle at RollOver" },
  { src: signage, alt: "RollOver sign inside the café" },
];

export const socialPhotos = [
  { src: deathByChocolate, alt: "Death by Chocolate dessert at RollOver" },
  { src: pour, alt: "Sauce being poured over a dessert at the RollOver counter" },
  { src: rollsSnicker, alt: "Snickers ice cream rolls at RollOver" },
];
